var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{ref:"treeBox",staticClass:"global-tree",attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"node-key":"uni","highlight-current":true,"default-expand-all":true,"expand-on-click-node":false},on:{"node-click":_vm.handleNodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }